import React from 'react';
import {Button, DatePicker, Form, Select} from 'antd';
import {SearchOutlined} from '@ant-design/icons';
import locale from 'antd/lib/date-picker/locale/es_ES';
import moment from 'moment';

const {RangePicker} = DatePicker;
const {Option} = Select;

/* Rangos rápidos del filtro de periodo. Se calculan en cada render
   para que "Hoy" siga siendo hoy en sesiones largas. */
const getRangePresets = () => ({
    'Hoy': [moment().startOf('day'), moment().endOf('day')],
    'Últimos 7 días': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    'Últimos 30 días': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    'Mes actual': [moment().startOf('month'), moment().endOf('day')],
    'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Lo que llevamos del año': [moment().startOf('year'), moment().endOf('day')],
    'Año actual': [moment().startOf('year'), moment().endOf('year')],
    'Año anterior': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
});

/* El primer formato es el de visualización; los demás permiten escribir la
   fecha con variantes comunes (un dígito, guiones, sin separadores). */
const DATE_INPUT_FORMATS = ['DD/MM/YYYY', 'D/M/YYYY', 'DD-MM-YYYY', 'D-M-YYYY', 'DDMMYYYY'];

export const ReportFilterHeader = ({title = 'Filtros de búsqueda', description = 'Seleccione los criterios para generar el reporte.'}) => (
    <div className="report-filter-header">
        <h3>{title}</h3>
        <p>{description}</p>
    </div>
);

export const CustomerFilterItem = ({customerList = []}) => (
    <Form.Item className="report-filter-item" label="Cliente" name="customer" extra="Busque por nombre del cliente."
               rules={[{required: true, message: 'Seleccione un cliente'}]}>
        <Select showSearch optionFilterProp="children"
                filterOption={(input, option) =>
                    String(option.children).toLowerCase().includes(input.toLowerCase())
                }
                placeholder={'Buscar o seleccionar cliente'} className="w-100">
            {customerList.map(customer => <Option key={customer.id} value={customer.id}>{customer.name}</Option>)}
        </Select>
    </Form.Item>
);

export const DateRangeFilterItem = () => (
    <Form.Item className="report-filter-item" label="Periodo del reporte" name="range"
               extra="Elija un rango rápido (Hoy, Mes actual, Año anterior…), seleccione en el calendario o escriba las fechas como dd/mm/aaaa."
               rules={[{required: true, message: 'Seleccione la fecha inicial y final'}]}>
        <RangePicker locale={locale} className="w-100" ranges={getRangePresets()}
                     format={DATE_INPUT_FORMATS}/>
    </Form.Item>
);

export const ReportFilterActions = ({children = 'Generar reporte'}) => (
    <Form.Item className="report-filter-actions">
        <Button className="commercial-primary-button report-submit-button" htmlType="submit" type="primary"
                icon={<SearchOutlined/>} size="large">{children}</Button>
    </Form.Item>
);
